import React from 'react'
import ReactDOM from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'
import { initSentry } from '@trinity/utils'

const sentryDsn = 'https://d1f9c19c43edd2121cba060c9cfd7f68@o170893.ingest.sentry.io/4505964977389568'
const sentryRelease = `skiffle@${__APP_VERSION__}`
initSentry(sentryDsn, sentryRelease)

React.startTransition(() => {
  ReactDOM.hydrateRoot(
    document,
    <React.StrictMode>
      <HydratedRouter />
    </React.StrictMode>,
  )
})
